<script lang="ts">
  // *** This file is part of DbGate Premium ***

  import InlineButton from '../buttons/InlineButton.svelte';
  import FormCheckboxField from '../forms/FormCheckboxField.svelte';
  import FormFieldTemplateLarge from '../forms/FormFieldTemplateLarge.svelte';
  import FormSelectField from '../forms/FormSelectField.svelte';
  import SelectField from '../forms/SelectField.svelte';
  import FontIcon from '../icons/FontIcon.svelte';
  import FormConnectionSelect from '../impexp/FormConnectionSelect.svelte';
  import FormDatabaseSelect from '../impexp/FormDatabaseSelect.svelte';
  import { useArchiveFolders } from '../utility/metadataLoaders';
  import FormDataDeployColumnList from './FormDataDeployColumnList.svelte';
  import FormDataDeployOperationWithCondition from './FormDataDeployOperationWithCondition.svelte';

  $: archiveFolders = useArchiveFolders();

  export let selectedTable;
  export let changeTable;
  export let dbinfo;

  // $: console.log('selectedTable', selectedTable);
</script>

<FormConnectionSelect name="conid" label="Database server" isNative allowChooseModel notSelected />
<FormDatabaseSelect conidName="conid" name="database" label="Database" isNative notSelected />
<FormSelectField
  name="archiveFolder"
  label="Data archive"
  isNative
  options={($archiveFolders || []).map(x => ({
    label: x.name,
    value: x.name,
  }))}
  notSelected
/>

{#if selectedTable}
  <h3>{selectedTable?.name}</h3>

  <FormDataDeployColumnList label="Key (match columns)" field="matchColumns" {selectedTable} {changeTable} />
  <!-- <FormFieldTemplateLarge label="Key (match columns)" type="combo">
    {#key selectedTable?.name + '||' + selectedTable.matchColumns.length}
      {#each selectedTable.matchColumns as col, index}
        <div class="flex flex1">
          <SelectField
            isNative
            value={col}
            on:change={e => {
              changeTable(selectedTable.name, table => ({
                ...table,
                matchColumns: selectedTable.matchColumns.map((v, i) => (i == index ? e.detail : v)),
              }));
            }}
            options={$dbinfo?.tables
              ?.find(x => x.pureName?.toUpperCase() == selectedTable.name.toUpperCase())
              ?.columns?.map(col => ({
                label: col.columnName,
                value: col.columnName,
              })) || []}
          />
          {#if index == 0}
            <InlineButton
              on:click={() => {
                const matchColumn1 =
                  selectedTable.tableInfo?.primaryKey?.columns?.[0]?.columnName ??
                  selectedTable.tableInfo?.columns?.[0]?.columnName;

                changeTable(selectedTable.name, table => ({
                  ...table,
                  matchColumns: [...selectedTable.matchColumns, matchColumn1],
                }));
              }}
              title="Add match column"
              square
            >
              <FontIcon icon="icon plus-thick" />
            </InlineButton>
          {:else}
            <InlineButton
              on:click={() => {
                changeTable(selectedTable.name, table => ({
                  ...table,
                  matchColumns: selectedTable.matchColumns.filter((x, i) => i != index),
                }));
              }}
              title="Remove match column"
              square
            >
              <FontIcon icon="icon minus-thick" />
            </InlineButton>
          {/if}
        </div>
      {/each}
    {/key}
  </FormFieldTemplateLarge> -->

  <h3>{selectedTable?.name} - deploy</h3>

  <FormDataDeployOperationWithCondition
    {selectedTable}
    {changeTable}
    checkLabel="Find existing row"
    filterLabel="Find condition"
    field="findExisting"
    filterField="findCondition"
    testidBase='DataDeploySettings_find'
  />

  {#if selectedTable?.findExisting}
    <FormDataDeployOperationWithCondition
      {selectedTable}
      {changeTable}
      checkLabel="Update existing row"
      filterLabel="Update condition"
      field="updateExisting"
      filterField="updateCondition"
      testidBase='DataDeploySettings_update'
      />

    <FormDataDeployOperationWithCondition
      {selectedTable}
      {changeTable}
      checkLabel="Delete missing row"
      field="deleteMissing"
      testidBase='DataDeploySettings_delete'
    />
    {#if selectedTable?.deleteMissing}
      <FormDataDeployColumnList
        label="Delete restriction columns"
        field="deleteRestrictionColumns"
        {selectedTable}
        {changeTable}
        allowNoColumns
        />
    {/if}
  {/if}

  <FormDataDeployOperationWithCondition
    {selectedTable}
    {changeTable}
    checkLabel="Create new row"
    filterLabel="Create condition"
    field="createNew"
    filterField="createCondition"
    testidBase='DataDeploySettings_create'
    />
{/if}

<h3>Global data deploy options</h3>
<FormCheckboxField label="Dry run - no changes (rollback when finished)" name="rollbackAfterFinish" />
<FormCheckboxField label="Skip rows with unresolved mandatory references" name="skipRowsWithUnresolvedRefs" />
<FormCheckboxField label="Set NULL for nullable unresolved references" name="setNullForUnresolvedNullableRefs" />

<style>
  h3 {
    margin: var(--dim-large-form-margin);
  }
</style>
